import React, { useState } from 'react';
import { Route, Routes, Link } from 'react-router-dom';

// Internal
import { signInWithGoogle, signInWithEmailAndPassword } from '../services/firebase';
import { Columns, Column } from '../components/Grid';
import Typography from '../components/Typography';
import Register from './register';
import ResetPassword from './reset-password';

// Antd
import { Form, Input, Button, Space } from 'antd';

// Icons
import { Mail, Key } from 'react-feather';
import { CopyrightOutlined } from '@ant-design/icons';

// Misc
import LOGO from '../img/logo.svg';
import GITHUB from '../img/pages/login/github.svg';
import GOOGLE from '../img/pages/login/google.svg';
import TWITTER from '../img/pages/login/twitter.svg';

// Styles
import styles from './login.module.scss';

const Login = () => {
  return (
    <>
      <Space direction="vertical" className={styles.loginPage__container__form__methods}>
        <Typography type="display_sm" weight="semibold">
          Welcome back
        </Typography>

        <Typography type="text_md" color="secondary">
          Welcome back! Please enter your details.
        </Typography>

        <EmailLogin />

        {/* <Button onClick={signInWithGithub} size="large">
          <img src={GITHUB} /> Sign in with Github
        </Button>

        <Button onClick={signInWithTwitter} size="large">
          <img src={TWITTER} /> Sign in with Twitter
        </Button> */}

        <div className={styles.loginPage__container__form__signup__message}>
          <Typography type="text_sm" color="secondary">
            Don't have an account? <Link to="/register">Sign up</Link>
          </Typography>
        </div>
      </Space>
    </>
  );
};

const EmailLogin = () => {
  const onFinish = (values: any) => {
    signInWithEmailAndPassword(values.email, values.password);
  };

  return (
    <Form onFinish={onFinish}>
      <Form.Item
        name="email"
        rules={[
          { required: true, message: 'Missing email address' },
          { type: 'email', message: 'Invalid email address' },
        ]}
      >
        <Input prefix={<Mail />} placeholder="Email address" size="large" />
      </Form.Item>

      <Form.Item name="password" rules={[{ required: true, message: 'Missing password' }]}>
        <Input prefix={<Key />} type="password" placeholder="Password" size="large" />
      </Form.Item>

      <Form.Item>
        <Link to="/reset-password">Forgot password</Link>
      </Form.Item>

      <Button type="primary" htmlType="submit" size="large">
        Log in
      </Button>

      <Button onClick={signInWithGoogle} size="large" style={{ marginTop: '1rem' }}>
        <img src={GOOGLE} /> Sign in with Google
      </Button>
    </Form>
  );
};

export default function LoginPage() {
  return (
    <div className={styles.loginPage}>
      <Columns className={styles.loginPage__columns}>
        <Column className={styles.loginPage__content}>
          <div className={styles.loginPage__container}>
            <div className={styles.loginPage__container__section}>
              <div className={styles.loginPage__container__logo}>
                <Link to="/">
                  <img src={LOGO} />
                </Link>
              </div>
            </div>

            <div className={styles.loginPage__container__spacer}></div>

            <div
              className={[
                styles.loginPage__container__section,
                styles.loginPage__container__form,
              ].join(' ')}
            >
              <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/reset-password" element={<ResetPassword />} />
              </Routes>
            </div>

            <div className={styles.loginPage__container__spacer}></div>

            <div className={styles.loginPage__container__section}>
              <div className={styles.loginPage__container__footer}>
                <Typography type="text_sm" color="secondary">
                  <CopyrightOutlined /> Paisley 2022
                </Typography>
              </div>
            </div>
          </div>
        </Column>

        <Column className={styles.loginPage__image}></Column>
      </Columns>
    </div>
  );
}
